import { getReviewId } from './Review';
import { REVIEW_METRIC_ROUTE, tokenizeRoute } from 'query/routes';
import { getCsrfToken } from 'query';

export const createReviewMetric = async (answer: string): Promise<void> => {
  const reviewId = getReviewId();
  if (!reviewId)
    throw new Error("Couldn't get Review ID. Is this part of a review?");

  const url = tokenizeRoute(REVIEW_METRIC_ROUTE, {
    review_id: reviewId,
  });

  return fetch(url.toString(), {
    method: 'POST',
    body: JSON.stringify({ time_saved_response: answer }),
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/json',
      'X-CSRF-Token': getCsrfToken(),
    },
  }).then((res) => res.json());
};
